import React from "react";
import { Form, FormGroup, Label, Input, Row, Col, Button } from "reactstrap";
import { useTranslation } from "../../hooks/useTranslation";

const FilterForm = ({
  startDate,
  endDate,
  codeFilter,
  brandFilter,
  handleStartDateChange,
  handleEndDateChange,
  handleCodeFilterChange,
  handleBrandFilterChange,
  handleSubmit,
  openTransferModal,
  selectAll,
  handleSale,
  resetFilteredProducts,
  saleButtonLabel,
}) => {
  const t = useTranslation();
  return (
    <Form onSubmit={handleSubmit}>
      {startDate !== undefined && endDate !== undefined && (
        <Row>
          <Col sm="6">
            <FormGroup>
              <Label for="startDate">{t("common.startDate") || "Start Date"}</Label>
              <Input
                type="date"
                id="startDate"
                value={startDate}
                onChange={handleStartDateChange}
              />
            </FormGroup>
          </Col>
          <Col sm="6">
            <FormGroup>
              <Label for="endDate">{t("common.endDate") || "End Date"}</Label>
              <Input
                type="date"
                id="endDate"
                value={endDate}
                onChange={handleEndDateChange}
              />
            </FormGroup>
          </Col>
        </Row>
      )}

      <Row>
        <Col sm="6">
          <FormGroup>
            <Label for="codeFilter">{t("products.filterByCode")}</Label>
            <Input
              type="text"
              id="codeFilter"
              value={codeFilter}
              onChange={handleCodeFilterChange}
            />
          </FormGroup>
        </Col>
        <Col sm="6">
          <FormGroup>
            <Label for="brandFilter">{t("products.filterByBrand")}</Label>
            <Input
              type="text"
              id="brandFilter"
              value={brandFilter}
              onChange={handleBrandFilterChange}
            />
          </FormGroup>
        </Col>
        <Col sm="12" style={{ textAlign: "end" }}>
          {openTransferModal !== undefined && (
            <Button color="success" size="sm" onClick={openTransferModal}>
              {t("products.transfer")}
            </Button>
          )}
          {selectAll !== undefined && (
            <Button color="secondary" size="sm" onClick={selectAll}>
              {t("common.showAll") || "Show All"}
            </Button>
          )}
          {handleSale !== undefined && (
            <Button size="sm" color="success" onClick={handleSale}>
              {saleButtonLabel || t("sales.sellSelected")}
            </Button>
          )}
          <Button size="sm" color="primary" type="submit">
            {t("common.filter") || "Filter"}
          </Button>
          {resetFilteredProducts !== undefined && (
            <Button size="sm" color="danger" onClick={resetFilteredProducts}>
              {t("products.resetFilters")}
            </Button>
          )}
        </Col>
      </Row>
    </Form>
  );
};

export default FilterForm;
